import React, { useContext } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import style from './footer.mod.scss'
import { Block, Button, Container, Logo } from '@components'
import Facebook from '@svgs/facebook.svg'
import Instagram from '@svgs/instagram.svg'
import ThemeContext from '@context/themeContext'

const Footer = () => {
  const classes = [style.footer]
  const { datoCmsGlobal } = useStaticQuery(graphql`
    {
      datoCmsGlobal {
        menuLinks: footerLinks {
          ...Link
        }
        facebook
        instagram
        footerEmail
      }
    }
  `)
  const { menuLinks = [], facebook, instagram, footerEmail } = datoCmsGlobal

  const { isWeCareNow } = useContext(ThemeContext)

  const socialMediaLinks = []
  facebook &&
    socialMediaLinks.push({
      url: facebook,
      id: 'facebook',
      children: <Facebook />
    })
  instagram &&
    socialMediaLinks.push({
      url: instagram,
      id: 'instagram',
      children: <Instagram />
    })

  return (
    <Container maxWidth={'xlarge'}>
      <footer className={classes.join(' ')}>
        <Block gutters>
          <Container maxWidth={'large'}>
            <div className={style.footer__upper}>
              <FooterNav menuLinks={menuLinks} />
              <FooterSocialMedia socialMediaLinks={socialMediaLinks} />
            </div>
            <div className={style.footer__lower}>
              <FooterLogo />
              <FooterMeta footerEmail={footerEmail} />
            </div>
          </Container>
        </Block>
      </footer>
    </Container>
  )
}

const FooterNav = ({ menuLinks = [] }) => {
  return (
    <Container maxWidth={'large'}>
      <nav className={style.footer__nav}>
        <ul>
          {menuLinks.map(item => (
            <li key={item.id}>
              <Button
                to={item.link?.path || item.url}
                children={item.displayText}
                unstyled
              />
            </li>
          ))}
        </ul>
      </nav>
    </Container>
  )
}

const FooterSocialMedia = ({ socialMediaLinks }) => {
  return (
    <div className={style['footer__social-media']}>
      <ul>
        {socialMediaLinks.map(item => {
          return (
            <li key={item.id}>
              <a href={item.url} target="_blank" rel="noopener noreferrer">
                {item.children}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

const FooterLogo = () => {
  return (
    <div className={style.footer__logo}>
      <Logo colour={'white'} />
    </div>
  )
}

const FooterMeta = ({ footerEmail }) => {
  const date = new Date()
  const year = date.getFullYear()
  return (
    <div className={style.footer__meta}>
      <div className={style.footer__contact}>
        <a href="tel:033498613">{'03 349 8613'}</a>
        <a href={`mailto:${footerEmail}`}>{footerEmail}</a>
      </div>
      <div className={style.footer__meta_wrap}>
        <p
          className={style.footer__copyright}
        >{`© ${year} WeCare - a brand of Wigram Health Limited.`}</p>
        <p className={style.footer__copyright}>
          {`Powered by `}
          <Button
            unstyled
            to={'https://www.strivedigital.co.nz/'}
            children={'Strive Digital'}
          />
          {'.'}
        </p>
      </div>
    </div>
  )
}

export default Footer
